import { useState } from 'react';

import { useLocation, useNavigate, useParams } from 'react-router-dom';

import useFeatureFlags from 'api/useFeatureFlags';
import { Analytics } from 'design-system/AcSidebar/constants';
import { TabsPanel } from 'design-system/TabPanel/TabPanel';
import { useTabTracking } from 'hooks/useTabTracking';

import PageTopBar from 'components/Topbar/PageTopBar';

const TAB_BUSINESS = 'Business';
const TAB_FINANCE = 'Finance';
const TAB_AB_TEST = 'A/B Test'

export enum EAnalyticsState {
  BUSINESS = 'business',
  FINANCE = 'finance',
  AB_TEST = 'ab-test',
}

const AnalyticsView: React.FC = () => {
  const { publisherId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const currentPath = location.pathname;
  const getCurrentTab = (): EAnalyticsState => {
    if (currentPath.includes('/finance')) return EAnalyticsState.FINANCE;
    if (currentPath.includes('/ab-test')) return EAnalyticsState.AB_TEST;
    return EAnalyticsState.BUSINESS;
  };

  const [tab, setTab] = useState<EAnalyticsState>(getCurrentTab());
  const { featureFlags } = useFeatureFlags({ publisherId });

  const basePath = `/project/${publisherId}`;
  const getAnalyticsPath = (basePath: string, state: EAnalyticsState) =>
    `${basePath}/statistics/${state}`;

  const tabs = [
    { label: TAB_BUSINESS, value: EAnalyticsState.BUSINESS },
    { label: TAB_FINANCE, value: EAnalyticsState.FINANCE },
    { label: TAB_AB_TEST, value: EAnalyticsState.AB_TEST },
  ];

  const { handleTabChangeWithEvent } = useTabTracking({
    sidebarTab: Analytics.title,
    tabs,
    customNavigate: (newValue) => {
      setTab(newValue as EAnalyticsState);
      navigate(getAnalyticsPath(basePath, newValue as EAnalyticsState));
    }
  });

  if (featureFlags === undefined) {
    return <></>;
  }

  return (
    <TabsPanel
      tabs={tabs}
      headerComponent={<PageTopBar withTabsDesign={true} headline="Analytics" />}
      handleTabChange={handleTabChangeWithEvent}
      activeTabVal={tab}
    />
  );
};

export default AnalyticsView;
